    <!-- #region Slider -->
    <section class="first" [ngClass]="lang" *ngIf="data?.length>=1">
      <div class="container-fluid">
        <div class="row">
          <div id="slider1">

            <!--Carousel Wrapper-->
            <div id="video-carousel-example" class="carousel slide fullScreen" data-ride="carousel">

              <!--Indicators-->

              <ol class="carousel-indicators">

                <li *ngFor="let item of data; let i=index" data-target="#video-carousel-example"
                  [attr.data-slide-to]="i" [class.active]="i==0">
                </li>

                <!-- <li data-target="#video-carousel-example" data-slide-to="1"></li>

                <li data-target="#video-carousel-example" data-slide-to="2"></li> -->

                <!-- <li data-target="#video-carousel-example" data-slide-to="3"></li> -->

              </ol>

              <!--/.Indicators-->

              <!--Slides-->
              <div class="carousel-inner" role="listbox">

                <!-- <div class="carousel-item active">
                  <video autoplay loop muted>
                    <source src="../../../../../assets/images/slider/Lantern-V01.mp4" type="video/mp4" />
                  </video>
                </div> -->

                <div *ngFor="let item of data; let i=index" [class.active]="i==0" class="carousel-item mt-auto"
                  [id]="item.id">

                  <div *ngIf="item.title && item.descrption"
                    [ngClass]="{'pr-5': lang=='en','pl-5': lang=='ar','mr-4': lang=='en','ml-2':lang=='ar'}"
                    class="container-fluid mt-auto fullScreen">

                    <div class="row mt-auto">
                      <img class="col-md-6 col-sm-12 m-auto ml-4" [src]="'./'+item.image" [alt]="item.title.en"
                        (load)="onLoading('image'+i)">
                      <div [id]="'image'+i" class="spinner-grow text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                      <article class="col-md-6 col-sm-12 m-auto p-1">
                        <h2 *ngIf="lang=='en'" class="text-center">{{item.title.en}}</h2>
                        <h2 *ngIf="lang=='ar'" class="text-center">{{item.title.ar}}</h2>
                        <P *ngIf="lang=='en'">
                          {{item.descrption.en}}
                        </P>
                        <P *ngIf="lang=='ar'">
                          {{item.descrption.ar}}
                        </P>
                        <button *ngIf="item.link && lang=='en'" (click)="link(item.link)">More</button>
                        <button *ngIf="item.link && lang=='ar'" (click)="link(item.link)">المزيد</button>
                      </article>
                    </div>

                  </div>

                  <div *ngIf="!item.title || !item.descrption">
                    <img class="fullScreen" [src]="'./'+item.image" alt="Slider">
                  </div>

                </div>
                <!--
                <div class="carousel-item">
                  <img src="../../../../../assets/images/slider/img2_en.jpg" alt="Slide">
                </div>

                <div class="carousel-item">
                  <img src="../../../../../assets/images/slider/img3_en.jpg" alt="Slide">
                </div> -->

              </div>
              <!--/.Slides-->

              <!--Controls-->

              <a class="carousel-control-prev" href="#video-carousel-example" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>

              <a class="carousel-control-next" href="#video-carousel-example" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>

              <!--/.Controls-->

            </div>
            <!--Carousel Wrapper-->

          </div>
        </div>
      </div>

      <span class="arrow" (click)="ArrowDown()">
        <svg width="18px" height="17px" viewBox="-1 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <g>
            <polygon class="arrow"
              points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596">
            </polygon>
            <polygon class="arrow-fixed"
              points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596">
            </polygon>
            <path
              d="M-4.58892184e-16,0.56157424 L-4.58892184e-16,16.1929159 L9.708,8.33860465 L-1.64313008e-15,0.56157424 L-4.58892184e-16,0.56157424 Z M1.33333333,3.30246869 L7.62533333,8.34246869 L1.33333333,13.4327013 L1.33333333,3.30246869 L1.33333333,3.30246869 Z">
            </path>
          </g>
        </svg>
      </span>

    </section>
    <!-- #endregion -->

    <section [ngClass]="lang" class="first" *ngIf="data.length<1 || data==null">
      <div class="container mt-auto">
        <div class="row mt-auto">
          <img class="col-md-5 col-sm-12 m-auto" src="../../../assets/images/logo/Company.svg"
            (load)="onLoading('imageD')">
          <div [id]="'imageD'" class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <article class="col-md-7 col-sm-12 m-auto p-5">
            <h2 *ngIf="lang=='en'" class="text-center">What we are...?</h2>
            <h2 *ngIf="lang=='ar'" class="text-center">ماذا نعمل...؟</h2>
            <P *ngIf="lang=='en'">

              The first Company Company was established in Riyadh in Saudi Arabia in 2001. The aim of the company was to be
              a
              technology pioneer providing innovative Business Solutions in those countries in the region that were
              developing as stable and fast growing economies.
              The success Company enjoyed meant that the company grew rapidly adding further offices internationally over
              subsequent years to include Sudan.
            </P>
            <P *ngIf="lang=='ar'">

              أسست شركة الشركة المحدودة في مدينة الرياض بالمملكة العربية السعودية منذ العام 2001، لقد كانت رؤيتنا منذ البدء
              ان نكون شركة رائدة تقدم حلول تقنية مبتكرة للاعمال في المملكة و البلدان ذات الاقتصادات النامية والمستقرة في
              المنطقة.
              خلال سنوات النجاح الذي حققته شركة الشركة والنمو المتسارع اسست الشركة عدة مكاتب اقليمية في المنطقة لتشمل
              السودان.
            </P>
          </article>
        </div>
      </div>

      <span class="arrow" (click)="ArrowDown()">
        <svg width="18px" height="17px" viewBox="-1 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <g>
            <polygon class="arrow"
              points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596">
            </polygon>
            <polygon class="arrow-fixed"
              points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596">
            </polygon>
            <path
              d="M-4.58892184e-16,0.56157424 L-4.58892184e-16,16.1929159 L9.708,8.33860465 L-1.64313008e-15,0.56157424 L-4.58892184e-16,0.56157424 Z M1.33333333,3.30246869 L7.62533333,8.34246869 L1.33333333,13.4327013 L1.33333333,3.30246869 L1.33333333,3.30246869 Z">
            </path>
          </g>
        </svg>
      </span>
    </section>
